module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "dialog-demo",
    model: {
      value: (_vm.showScrollBox),
      callback: function($$v) {
        _vm.showScrollBox = $$v
      },
      expression: "showScrollBox"
    }
  }, [_c('p', {
    staticClass: "dialog-title"
  }, [_vm._v("服务协议")]), _vm._v(" "), _c('div', {
    staticClass: "img-box",
    staticStyle: {
      "height": "80%",
      "padding": "15px 10px",
      "overflow": "scroll",
      "-webkit-overflow-scrolling": "touch",
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "flight-mask-cnt-new",
    domProps: {
      "innerHTML": _vm._s(_vm.data)
    }
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.showSc
    }
  }, [_c('span', {
    staticClass: "vux-close"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-070db4c1"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Agreement.vue
// module id = 379
// module chunks = 1